import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class RemoveIcon extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon fill="#000000" height="24" viewBox="0 0 24 24" width="24" {...this.props}>
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" />
            </SvgIcon>
        );
    }
}
